module.exports = __webpack_public_path__ + "img/part9-3.ea70f154.png";